import { useModalStore } from '~/stores/modal.store.ts'

export interface IModal {
  id: string
  tabId: string
  state: boolean
  data?: Record<string, string | object | number | null>
  description: string
}

export function useModal() {
  const store = useModalStore()

  function openModal(
    modelId: string,
    tabId?: string,
    forceCloseAllModal: boolean = false,
    description: string = ''
  ): void {
    if (forceCloseAllModal) {
      closeAllModal()
    }
    store.addModal(modelId, tabId, description)
  }

  function updateModal(modalData: IModal): void {
    store.updateModal(modalData)
  }

  function closeModal(modelId: string): void {
    store.removeModal(modelId)
  }

  function getModal(modelId: string): IModal {
    return store.getModal(modelId)
  }

  function closeAllModal(): void {
    store.reset()
  }

  return {
    openModal,
    updateModal,
    getModal,
    closeModal,
    closeAllModal
  }
}
